// extracted by mini-css-extract-plugin
export default {"wrap":"Parallax_wrap__PIjVx","inner":"Parallax_inner__SxhgC"};